<div #containerRef>

    <div class="totals-container">
        <div class="total-block">
            <h3>Token Balance</h3>
            <p class="total">R{{tokenBalance}}</p>
        </div>
        <div class="total-block">
            <h3>Usage This Week</h3>
            <p class="total">R{{thisWeekTotal}}</p>
        </div>
        <div class="total-block">
            <h3>Usage This Month</h3>
            <p class="total">R{{thisMonthTotal}}</p>
        </div>
    </div>


    <div class="filter-controls">
        <mat-chip-listbox [(ngModel)]="usageFilterValue" (change)="onUsageFilterSelection($event)">
            <mat-chip-option value="week">Last Week</mat-chip-option>
            <mat-chip-option value="month">Last Month</mat-chip-option>
            <mat-chip-option value="all">All Time</mat-chip-option>
        </mat-chip-listbox>

        <div class="control-row">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Start Date</mat-label>
                <input matInput [matDatepicker]="startDatePicker" [(ngModel)]="filterOptions.startDate"
                    placeholder="DD/MM/YYYY" (dateChange)="loadUsage()" [max]="maxDate">
                <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #startDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>End Date</mat-label>
                <input matInput [matDatepicker]="endDatePicker" [(ngModel)]="filterOptions.endDate"
                    placeholder="DD/MM/YYYY" (dateChange)="loadUsage()">
                <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #endDatePicker></mat-datepicker>
            </mat-form-field>
        </div>
    </div>

    <ng-container
        *ngIf="chartData && chartData.length > 0 && chartData[0].series && chartData[0].series.length > 0; else noUsageTemplate">

        <ngx-charts-line-chart class="ngx-chart" [view]="[containerRef.offsetWidth, 400]" [scheme]="colorScheme"
            [legend]="showLegend" [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel"
            [xAxis]="showXAxis" [yAxis]="showYAxis" [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel"
            [timeline]="timeline" [autoScale]="autoScale" [results]="chartData">
        </ngx-charts-line-chart>

        <ng-container *ngIf="barChartData && barChartData.length > 0">
            <ngx-charts-bar-vertical class="ngx-chart" [view]="[containerRef.offsetWidth, barHeight]"
                [scheme]="barColorScheme" [results]="barChartData" [gradient]="gradient" [xAxis]="true" [yAxis]="true"
                [legend]="false" [showXAxisLabel]="true" [showYAxisLabel]="true" [xAxisLabel]="'User'"
                [yAxisLabel]="'Usage (ZAR)'" [legendPosition]="legendPosition">
            </ngx-charts-bar-vertical>
        </ng-container>

    </ng-container>

</div>




<ng-template #noUsageTemplate>
    <p class="grey-text">No usage found for the selected date range.</p>
</ng-template>